import * as React from "react";

import type { AuditLogQuery } from "api/auditLogs";
import { Button } from "Components/ui";
import { Download } from "Components/ui/icons";
import { AuditLogExplorer } from "Routes/AuditLogs/Components/AuditLogExplorer";
import { useAuditLogsData } from "Routes/AuditLogs/data";

type AuditLogTableProps = {
  /** Heading above the list; defaults to "Audit logs". */
  title?: string;
  /** Merged into every request, e.g. `{ targetId, limit }`; `limit` also sets the page size. */
  query?: AuditLogQuery;
  hideTitle?: boolean;
  /** Caps the table's scroll height, e.g. "60vh" or 480 (px). */
  maxHeight?: number | string;
};

/**
 * Embeddable audit log list (filters, table, pager, detail sheet) for places without a page
 * header, such as the tenant "Audit history" dialog. The Audit logs page composes the same parts.
 */
const AuditLogTable: React.FC<AuditLogTableProps> = ({
  title,
  query,
  hideTitle = false,
  maxHeight,
}) => {
  const data = useAuditLogsData(query);

  return (
    <div className="space-y-4">
      {!hideTitle && (
        <h2 className="text-lg font-semibold tracking-tight text-foreground">
          {title || "Audit logs"}
        </h2>
      )}
      <AuditLogExplorer
        data={data}
        maxHeight={maxHeight}
        toolbarActions={
          <Button
            variant="secondary"
            leftIcon={<Download />}
            loading={data.exporting}
            onClick={() => void data.exportCsv()}
          >
            Export CSV
          </Button>
        }
      />
    </div>
  );
};

export default AuditLogTable;
